import actionCreatorFactory from 'typescript-fsa';

import { ErrorWrapper } from 'store/base';
import { TerminalApi } from 'api/Terminal.api';
import { toastr } from 'react-redux-toastr';

import CommonUtilities from 'helpers/CommonUtilities';
import TerminalResponseViewModel from '../../ViewModels/TerminalResponseViewModel';
import { Dispatch } from 'redux';
import LocaleUtilities from '../../../../../../helpers/LocaleUtilities';

const actionCreator = actionCreatorFactory();
const type = 'TERMINAL/CREATE/SUBMIT';
export const asyncActions = actionCreator.async<{}, {}, ErrorWrapper>(type);

export default function submitCreateAction(formValues: TerminalResponseViewModel) {
  return async (dispatch: Dispatch<any>) => {
    let id: string | undefined = undefined;

    async function mainAction(): Promise<void> {
      dispatch(asyncActions.started({}));
      if (formValues.address?.lng) formValues.address.lng = formValues.address?.lng.toString();
      if (formValues.address?.lat) formValues.address.lat = formValues.address?.lat.toString();
      const response = await TerminalApi.add(formValues);
      if (response) id = response;
      dispatch(asyncActions.done({ params: {}, result: {} }));
      toastr.success(
        LocaleUtilities.i18n('toastr-success-title-Successful', 'base.message', true),
        LocaleUtilities.i18n('toastr-Data saved successfully', 'base.message', true),
      );
    }

    async function catchAction(exception: any): Promise<void> {
      dispatch(asyncActions.failed({ params: {}, error: exception }));
      toastr.error(
        LocaleUtilities.i18n('toastr-error-title-Error', 'base.message', true),
        LocaleUtilities.i18n('toastr-Data not saved', 'base.message', true),
      );
    }

    dispatch(asyncActions.started({}));
    await CommonUtilities.tryCatchWrapper(mainAction, catchAction);
    return id;
  };
}
